'use client';

export default function Error({
  error: _error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4">
      <div className="text-center p-8 max-w-md bg-red-50 border border-red-200 rounded-lg">
        <h2 className="text-xl font-semibold mb-2 text-red-600">
          Something went wrong
        </h2>
        <p className="text-ink-600 mb-6">
          An unexpected error occurred. Please try again.
        </p>
        <button
          onClick={reset}
          className="px-6 py-2 text-white font-semibold rounded-lg transition-colors bg-brand-600 hover:bg-brand-700"
        >
          Try Again
        </button>
      </div>
    </div>
  );
}
